import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconEdit",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ a("path", { d: "M.94 1.94A1.5 1.5 0 0 1 2 1.5h3.5a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V6.5a.5.5 0 0 1 1 0V10A1.5 1.5 0 0 1 9 11.5H2A1.5 1.5 0 0 1 .5 10V3c0-.398.158-.78.44-1.06Z" }, null, -1), p = /* @__PURE__ */ a("path", { d: "M10 1.44a.56.56 0 0 0-.396.164L4.95 6.256l-.264 1.057 1.057-.264 4.652-4.653A.56.56 0 0 0 10 1.44ZM8.896.895a1.56 1.56 0 0 1 2.208 2.208l-4.75 4.75a.5.5 0 0 1-.233.131l-2 .5a.5.5 0 0 1-.606-.606l.5-2a.5.5 0 0 1 .131-.233l4.75-4.75Z" }, null, -1), f = [
  h,
  p
], m = ["id"], g = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  g
];
function I(e, b, d, q, S, t) {
  return r(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--edit"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Edit",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, f, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, m)
    ])
  ], 10, _);
}
const C = /* @__PURE__ */ s(c, [["render", I]]);
export {
  C as default
};
//# sourceMappingURL=edit.js.map
